module.exports = __webpack_public_path__ + "font-awesome.fee66e712a8a08eef580.woff";


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/fonts/font-awesome/font-awesome.woff?v=4.7.0
// module id = ../../../../../src/fonts/font-awesome/font-awesome.woff?v=4.7.0
// module chunks = styles